import React from "react"
//  import Image from "gatsby-image"
import Bio from "../bio/bio"

const HomeActions = () => {
    return (
        <aside className="buttons wrapper bio-wrapper">  
            <Bio /> 
        </aside>
    )
}

export default HomeActions
